import { apiClient, API_CONFIG } from '@/api/core';
import { buildQueryString } from '@/api/shared/queryBuilder';
import type { ApiResponse } from '@/api/shared';
import type { LC_MonthlyCutYearItemOut, MonthlyCutYearItem } from './monthlyCutsYears.types';
import { mapMonthlyCutYearItem } from './monthlyCutsYears.mapper';


export class MonthlyCutsYearsService {
  async getYears(
    filterCompanyIdOrSignal?: string | null | AbortSignal,
    signal?: AbortSignal,
  ): Promise<ApiResponse<MonthlyCutYearItem[]>> {
    let filterCompanyId: string | null | undefined;
    let abortSignal: AbortSignal | undefined;

    if (filterCompanyIdOrSignal instanceof AbortSignal) {
      abortSignal = filterCompanyIdOrSignal;
    } else {
      filterCompanyId = filterCompanyIdOrSignal;
      abortSignal = signal;
    }

    const query = buildQueryString(filterCompanyId ? { filterCompanyId } : {});
    const response = await apiClient.get<LC_MonthlyCutYearItemOut[]>(
      `${API_CONFIG.ENDPOINTS.CATALOG.MONTHLY_CUTS_YEARS}${query}`,
      { signal: abortSignal },
    );

    if (!response.success || !response.data) {
      return { ...response, data: null };
    }

    return { ...response, data: response.data.map(mapMonthlyCutYearItem) };
  }
}

export const monthlyCutsYearsService = new MonthlyCutsYearsService();
